import { createSlice } from "@reduxjs/toolkit";

const getSystemPreference = () => {
    const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    return systemPrefersDark ? "dark-mode" : "light-mode";
};

const DarkModeSlice = createSlice({
    name: "darkMode",
    initialState: getSystemPreference(),
    reducers: {
        toggleDarkMode(state) {
            return state === "light-mode" ? "dark-mode" : "light-mode";
        },
        setDarkMode(state, action) {
            return action.payload;
        }
    },
});

export const { toggleDarkMode, setDarkMode } = DarkModeSlice.actions;
export default DarkModeSlice.reducer;
